import { render, staticRenderFns } from "./SlitCoil.vue?vue&type=template&id=ae197c4e&scoped=true&"
import script from "./SlitCoil.vue?vue&type=script&lang=js&"
export * from "./SlitCoil.vue?vue&type=script&lang=js&"
import style0 from "./SlitCoil.vue?vue&type=style&index=0&id=ae197c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae197c4e",
  null
  
)

export default component.exports